module.exports = __webpack_public_path__ + "media/images/thumbs/pathophys/2pNUyxucGIesg2woeAIs2w-5b7582de08b7658dac3ea916b18b2db4.jpg";